import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { throwError } from "rxjs";

function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable({
  providedIn: "root",
})
export class PaymentService {
  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient, private auth: AuthService) {}

  initCoursePayment(course_id: number) {
    let headers = new HttpHeaders();
    headers = headers.set("Authorization", "bearer " + this.auth.getToken());
    return this.http
      .post(`${this.baseUrl}v1/order/rc/${course_id}/`, {}, { headers })
      .pipe(catchError(this.handleError));
  }

  initPayment(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set("Authorization", "Bearer " + this.auth.getToken());
    return this.http
      .post(`${this.baseUrl}v1/payment/init/`, body, { headers })
      .pipe(catchError(this.handleError));
  }
  confirmPayment(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set("Authorization", "Bearer " + this.auth.getToken());
    return this.http
      .post(`${this.baseUrl}v1/payment/status/`, body, { headers })
      .pipe(catchError(this.handleError));
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  get nativeWindow(): any {
    return _window();
  }
}
